import React from "react";
import {
  DefaultContextMenu,
  TLUiContextMenuProps,
  TldrawUiMenuGroup,
  TldrawUiMenuItem,
  CursorChatItem,
  ArrangeMenuSubmenu,
  ReorderMenuSubmenu,
  MoveToPageMenu,
  ClipboardMenuGroup,
  SelectAllMenuItem,
  useShowCollaborationUi,
  useValue,
  useEditor,
  TldrawUiMenuSubmenu,
  TldrawUiMenuActionItem,
  ConversionsMenuGroup,
  GroupMenuItem,
  UngroupMenuItem,
  EditLinkMenuItem,
  FitFrameToContentMenuItem,
  RemoveFrameMenuItem,
  ConvertToEmbedMenuItem,
  ConvertToBookmarkMenuItem,
  ToggleAutoSizeMenuItem,
  ToggleLockMenuItem,
} from "@tldraw/tldraw";
import "tldraw/tldraw.css";
import { useIsBuilderEmptyState } from "pages/flyer/builder/hooks/useIsBuilderEmptyState";

/** Shows Ungroup for groups (UngroupMenuItem) or for single mask result (same action, our override). */
function EditUngroupMenuItem() {
  const editor = useEditor();
  const allowStandardUngroup = useValue(
    "allowUngroup",
    () => editor.getSelectedShapeIds().some((id) => editor.getShape(id)?.type === "group"),
    [editor]
  );
  const allowMaskUngroup = useValue(
    "allowMaskUngroup",
    () => {
      const ids = editor.getSelectedShapeIds();
      if (ids.length !== 1) return false;
      return Boolean(editor.getShape(ids[0])?.meta?.isMaskShape);
    },
    [editor]
  );
  if (allowStandardUngroup) return <UngroupMenuItem />;
  if (allowMaskUngroup) return <TldrawUiMenuActionItem actionId="ungroup" />;
  return null;
}

/** Edit submenu with Ungroup for both groups and mask result. Uses only exported tldraw components (FlattenMenuItem is not exported, so we use flatten-to-image action). */
function CustomEditMenuSubmenu() {
  const editor = useEditor();
  const hasSelection = useValue("editMenuSelection", () => editor.getSelectedShapeIds().length >= 1, [editor]);
  if (!hasSelection) return null;
  return (
    // @ts-expect-error tldraw component return type mismatch
    <TldrawUiMenuSubmenu id="edit" label="context-menu.edit" size="small">
      <TldrawUiMenuActionItem actionId="flatten-to-image" />
      <EditLinkMenuItem />
      <FitFrameToContentMenuItem />
      <RemoveFrameMenuItem />
      <ConvertToEmbedMenuItem />
      <ConvertToBookmarkMenuItem />
      <ToggleAutoSizeMenuItem />
      <ToggleLockMenuItem />
    </TldrawUiMenuSubmenu>
  );
}

/** Uses tldraw's DefaultContextMenu so Menu context matches (avoids "MenuItem must be used within Menu").
 *  When in empty state or nothing is selected, render no menu items so the popup stays closed. */
export function CustomContextMenu(props: TLUiContextMenuProps) {
  return (
    <DefaultContextMenu {...props}>
      <DefaultContextMenuContent />
    </DefaultContextMenu>
  );
}

export function DefaultContextMenuContent() {
  const editor = useEditor();
  const showCollaborationUi = useShowCollaborationUi();
  const isEmptyState = useIsBuilderEmptyState();

  const selectToolActive = useValue("isSelectToolActive", () => editor.getCurrentToolId() === "select", [editor]);
  const isSinglePageMode = useValue("isSinglePageMode", () => editor.options.maxPages <= 1, [editor]);
  editor.options.defaultSvgPadding;

  if (!selectToolActive || isEmptyState) return null;

  return (
    <>
      {showCollaborationUi && <CursorChatItem />}
      {/* @ts-ignore */}
      <TldrawUiMenuGroup id="modify">
        <CustomEditMenuSubmenu />
        <ArrangeMenuSubmenu />
        <ReorderMenuSubmenu />
        {!isSinglePageMode && <MoveToPageMenu />}
      </TldrawUiMenuGroup>
      {/* @ts-ignore */}
      <TldrawUiMenuGroup id="group">
        <GroupMenuItem />
        <EditUngroupMenuItem />
      </TldrawUiMenuGroup>
      <ClipboardMenuGroup />
      <ConversionsMenuGroup />
      {/* @ts-ignore */}
      <TldrawUiMenuGroup id="select-all">
        <SelectAllMenuItem />
      </TldrawUiMenuGroup>
      {/* @ts-ignore */}
      <TldrawUiMenuGroup id="sidebar-toggle">
        <TldrawUiMenuItem
          id="toggle-sidebar"
          label="Show/Hide Sidebar"
          onSelect={() => {
            window.dispatchEvent(new CustomEvent("toggleSidebar"));
          }}
        />
      </TldrawUiMenuGroup>
    </>
  );
}

// export function ConversionsMenuGroup() {
//   const editor = useEditor();
//   const atLeastOneShapeOnPage = useValue("atLeastOneShapeOnPage", () => editor.getCurrentPageShapeIds().size > 0, [
//     editor,
//   ]);

//   if (!atLeastOneShapeOnPage) return null;

//   const handleExportAsPng = async () => {
//     const shapeIds = editor.getCurrentPageShapeIds();
//     if (shapeIds.size === 0) return alert("No shapes on the canvas");

//     const { blob } = await editor.toImage([...shapeIds], {
//       format: "png",
//       scale: 1,
//       background: false,
//       padding: editor.options.defaultSvgPadding,
//     });

//     const link = document.createElement("a");
//     link.href = window.URL.createObjectURL(blob);
//     link.download = "canvas.png";
//     link.click();
//   };

//   return (
//     <TldrawUiMenuGroup id="conversions">
//       <CopyAsMenuGroup />
//       <TldrawUiMenuSubmenu id="export-as" label="context-menu.export-as" size="small">
//         <TldrawUiMenuGroup id="export-as-group">
//           {/* <TldrawUiMenuActionItem actionId="export-as-svg" />
//           <TldrawUiMenuActionItem actionId="export-as-png" /> */}
//           <p>Custom export as svg</p>
//           <button onClick={handleExportAsPng}>Custom export as png</button>
//         </TldrawUiMenuGroup>
//         <TldrawUiMenuGroup id="export-as-bg">
//           <ToggleTransparentBgMenuItem />
//         </TldrawUiMenuGroup>
//       </TldrawUiMenuSubmenu>
//     </TldrawUiMenuGroup>
//   );
// }
